import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAxios from "vue-axios";
import axios from "axios";
import moment from "moment";
import "./constant";
import VueFlashMessage from "vue-flash-message";

Vue.config.productionTip = false;

// set api default url
axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
//
Vue.use(VueAxios, axios);

// use Flash Message
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 3000,
    important: true,
  },
});

// request
axios.interceptors.request.use((config) => {
  store.commit("loadingIncrement");
  return config;
});

// responce
axios.interceptors.response.use(
  (response) => {
    store.commit("loadingDecrement");
    return response;
  },
  (error) => {
    store.commit("loadingError");
    return Promise.reject(error);
  }
);

// filters
// in js
// Vue.filter('date_format')(this.eventinfo.start_date);
// in html
// {{ ticket.start_date | date_format }}
Vue.filter("date_format", (date: string) => {
  if (!date) {
    return "";
  }
  const target = moment(date);
  return target.format("YYYY/MM/DD");
});

Vue.filter("gender_disp", (type: number) => {
  if (type === 1) {
    return "男性";
  } else if (type === 2) {
    return "女性";
  }

  return "無設定";
});

Vue.filter("age", (birthday: string) => {
  if (!birthday) {
    return "";
  }
  const birth = moment(birthday);
  return moment().diff(birth, "years") + "歳";
});

Vue.filter("description", (text: string) => {
  if (text.length <= 30) {
    return text;
  }
  return text.substring(0, 30) + "...";
});

/* eslint-disable */
(async () => {
  await store.dispatch("auth/init");
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
})();
